import React from "react";
import Slider from "react-slick";
import {useMediaQuery} from 'react-responsive';
import {mobileMediaQuery, tabletVerticalMediaQuery} from "../../utils/media-queries";
import InfoGraphicItem from "./InfoGraphicItem";

const InfoGraphicItems = ({title, subtitle, images, itemWidth}) => {
  const isMobile = useMediaQuery(mobileMediaQuery());
  const isTabletV = useMediaQuery(tabletVerticalMediaQuery());
  const viewportWidth = window.innerWidth;
  const numSlidesToShow = isMobile
    ? 2
    : Math.min(5, Math.max(2, Math.ceil(viewportWidth / itemWidth)));

  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: numSlidesToShow,
    slidesToScroll: 1,
    mobileFirst: true,
    variableWidth: true,
    swipeToSlide: true,
  };

  if (isMobile || isTabletV) {
    return (
      <div>
        <h2 dangerouslySetInnerHTML={{__html: title}}></h2>
        {!isMobile && <h2>{subtitle}</h2>}
        <div className="outer-slider-wrapper">
          <div className="inner-slider-wrapper">
            <Slider {...settings}>
              {images.map(image => (
                <InfoGraphicItem
                  key={image.src}
                  img={image.src}
                  alt={image.alt}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        {images.map(image => (
          <InfoGraphicItem
            key={image.src}
            image={image.src}
            alt={image.alt}
          />
        ))}
      </div>
    );
  }
};

export default InfoGraphicItems;
